import { SingleStar, ArrowTour, ArrowLeft16 } from '@honeybook/icons';
import styled, { CSSProperties, css } from 'styled-components';
import HBButton from '../HBButton/HBButton';
import { CloseIcon } from '../HBProTip/HBProTip';
import HBText from '../HBText/HBText';
import { twinkle } from '../../styles/animations';
import { vars } from '../../theme';

export const Container = styled.div<{
    horizontalOffset?: number;
    verticalOffset?: number;
}>`
    background-color: ${vars.colors.surface.container};
    width: 343px;
    border-radius: ${vars.radius.xs};
    display: flex;
    flex-direction: column;
    position: relative;
    ${({ horizontalOffset }) =>
        horizontalOffset != null &&
        css`
            margin-left: ${horizontalOffset}px;
        `}
    ${({ verticalOffset }) =>
        verticalOffset != null &&
        css`
            margin-top: ${verticalOffset}px;
        `}
`;

export const TourActionsContainer = styled.div`
    position: relative;
    height: 50px;
    border-bottom: 1px solid ${vars.colors.stroke.secondary};
`;

export const InnerContainer = styled.div`
    display: flex;
    flex-direction: column;
    padding: 20px;
`;

export const InnerLastStepContainer = styled.div`
    display: flex;
    flex-direction: column;
    padding: 50px 20px 20px 20px;
`;

export const StyledArrowIcon = styled(ArrowLeft16)`
    cursor: pointer;
    position: absolute;
    left: 18px;
    top: 18px;
`;

export const StyledCloseIcon = styled(CloseIcon)`
    cursor: pointer;
    position: absolute;
    right: 18px;
    top: 18px;
`;

export const Header = styled.div`
    display: flex;
    align-items: center;
    margin-bottom: 2px;
`;

export const StyledGIF = styled.img`
    margin-bottom: 20px;
`;

export const Title = styled(HBText)`
    margin-left: 10px;
    margin-top: -4px;
`;

export const Description = styled(HBText)`
    white-space: pre-line;
`;

export const Footer = styled.div`
    margin-top: 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: row-reverse;
`;

export const StepCounter = styled.div`
    color: ${vars.colors.text.tertiary};
    font-size: 14px;
`;

export const NextButton = styled(HBButton)`
    border-radius: ${vars.radius.xs};
    display: flex;
    justify-content: center;
    align-items: center;
    color: ${vars.colors.text.invertedPrimary};
    height: auto;
    padding: 10px 17px;
    box-shadow: ${vars.shadow['20']};
`;

export const StyledLink = styled.a`
    color: inherit;
    text-decoration: underline;
    &:hover {
        color: inherit;
    }
`;

export const TourPixel = styled.div<{
    overrideStyle?: CSSProperties;
}>`
    width: 1px;
    height: 1px;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    ${({ overrideStyle }) => overrideStyle as any}
`;

export const TwinkleStar = styled(SingleStar)<{
    top?: number;
    bottom?: number;
    right?: number;
    left?: number;
    delay?: number;
    duration?: number;
}>`
    position: absolute;
    z-index: 1;
    animation: ${twinkle};
    animation-iteration-count: infinite;

    ${({ top }) =>
        top != null &&
        css`
            top: ${top}px;
        `}

    ${({ bottom }) =>
        bottom != null &&
        css`
            bottom: ${bottom}px;
        `}

    ${({ right }) =>
        right != null &&
        css`
            right: ${right}px;
        `}

    ${({ left }) =>
        left != null &&
        css`
            left: ${left}px;
        `}

    ${({ delay }) =>
        delay != null &&
        css`
            animation-delay: ${delay}ms;
        `}

    ${({ duration }) =>
        duration != null &&
        css`
            animation-duration: ${duration}ms;
        `}
`;

export const StyledArrowTour = styled(ArrowTour)<{
    top?: number;
    bottom?: number;
    right?: number;
    left?: number;
}>`
    position: absolute;
    z-index: 1;

    ${({ top }) =>
        top != null &&
        css`
            top: ${top}px;
        `}

    ${({ bottom }) =>
        bottom != null &&
        css`
            bottom: ${bottom}px;
        `}

    ${({ right }) =>
        right != null &&
        css`
            right: ${right}px;
        `}

    ${({ left }) =>
        left != null &&
        css`
            left: ${left}px;
        `}
`;
